import { TRPCReactQueryError } from '@sternum/web/services/trpc';

export function extractRateLimitFromHeaders(headers: Headers) {
  return {
    rateLimit: parseInt(headers.get('x-ratelimit-limit')!, 10),
    rateLimitRemaining: parseInt(headers.get('x-ratelimit-remaining')!, 10),
    rateLimitReset: new Date(headers.get('x-ratelimit-reset')!),
  };
}

export function extractRateLimitFromError(error: TRPCReactQueryError) {
  const meta = error.meta as { response: Response };

  if (!meta?.response) {
    console.log(error.meta);
    throw new Error('Invalid error response meta');
  }

  return extractRateLimitFromHeaders(meta.response.headers);
}
